import React from 'react';


const SkillCircle = ({ skill, percentage }) => {
    const radius = 50;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (percentage / 100) * circumference;
// Agregar console.log para verificar los valores
console.log(`Skill: ${skill}`);
console.log(`Circumference: ${circumference}`);
console.log(`Offset (stroke-dashoffset): ${offset}`);
    return (
        <div className="skill-circle">
            <svg width="120" height="120" className="circle-chart">
                <circle
                    className="circle-chart-background"
                    cx="60"
                    cy="60"
                    r={radius}
                    strokeWidth="10"
                />
                <circle
                    className="circle-chart-progress"
                    cx="60"
                    cy="60"
                    r={radius}
                    strokeWidth="10"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                />
            </svg>
            <div className="skill-circle-label">
                <strong>{skill}</strong>
                <p>{percentage}%</p>
            </div>
        </div>
    );
};

export default SkillCircle;
